import dxDataGrid from 'devextreme/ui/data_grid';
import DataGrid from 'devextreme-react/data-grid';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { refreshTokens, checkSession } from '@adserve/adserve-react-components';

import { TColumns } from 'types/columnDefs';
import { TData } from 'types/rowDefs';

/* -------------------- */

export const getCustomStore = (
    dataUrl: string | undefined | null,
    columns: TColumns,
    onDataLoaded: ((rows: TData) => void) | undefined
) => {
    if (dataUrl) {
        const dateFields = columns ? columns.filter(c => c.type === 'date').map(c => c.field as string) : [];
        refreshTokens();

        const dataStore = createStore({
            key: 'id',
            loadMode: 'processed',

            loadMethod: 'GET',
            loadUrl: dataUrl,

            onLoading: (loadOptions) => {
                if (loadOptions.sort) {
                    loadOptions.sort.forEach((opt: { desc: boolean, selector: any; }) => {
                        if (typeof opt.selector !== 'string' && Boolean(opt.selector?.context?.column?.name)) {
                            opt.selector = opt.selector.context.column.name;
                        }
                    })
                }
            },
            onBeforeSend: async (operation, ajaxSettings) => {
                switch (operation) {
                    case 'load':
                    default:
                        await checkSession();
                        const idToken = localStorage.getItem('AdserveIdToken');
                        ajaxSettings.headers = { Authorization: `Bearer ${idToken}` };
                        break;
                }
            },
            onLoaded: (result: any[]) => {
                if (result && dateFields.length) {
                    for (const row of result) {
                        for (const field of dateFields) {
                            row[field] = new Date(row[field]);
                        }
                    }
                }
                if (onDataLoaded) {
                    onDataLoaded(result);
                }
            },
            onAjaxError: ({ xhr, error }) => {
                console.error('DexExtreme CustomStore Ajax Error:', xhr, error);
            }
        });
        return dataStore;
    }
    return undefined;
};

